import {
  ELKJOP_DEVICE_DEALER_IDS,
  ELKJOP_CUSTOMER_IDS,
  MOBIT_CUSTOMER_IDS,
  MOBIT_DEVICE_DEALER_ID,
  MOBIT_WHITE_LABEL_ID,
  MULTI_CONSULT_CUSTOMER_IDS,
  SKYTECH_CUSTOMER_ID,
} from '@skytech/utils/constants'
import { useQuery } from '@tanstack/react-query'

import { commonQueries } from '@/resources/queries'
import userResources from '@/resources/user'

const useUser = () =>
  useQuery(commonQueries.user(), userResources.get, {
    staleTime: Infinity,
  }).data

export default useUser

export const useProfile = () =>
  useQuery(commonQueries.profile(), userResources.getProfile, {
    staleTime: Infinity,
  }).data

export const useIsElkjop = () => {
  const user = useUser()

  if (!user) return false

  return ELKJOP_CUSTOMER_IDS.includes(user.customerId)
}

export const useIsElkjopCustomer = () => {
  const profile = useProfile()

  if (!profile) return false

  return ELKJOP_DEVICE_DEALER_IDS.includes(profile.deviceDealerUserId)
}

export const useIsMobit = () => {
  const user = useUser()

  if (!user) return false

  return MOBIT_CUSTOMER_IDS.includes(user.customerId)
}

export const useIsMobitCustomer = () => {
  const user = useUser()
  const profile = useProfile()

  if (!user || !profile) return false

  return (
    profile.deviceDealerUserId === MOBIT_DEVICE_DEALER_ID ||
    user.whiteLabelId === MOBIT_WHITE_LABEL_ID
  )
}

export const useIsMultiConsult = () => {
  const user = useUser()

  if (!user) return false

  return MULTI_CONSULT_CUSTOMER_IDS.includes(user.customerId)
}

export const useIsSkytech = () => {
  const user = useUser()

  if (!user) return false

  return user.customerId === SKYTECH_CUSTOMER_ID
}

export const useEditTranslationsPrivilege = () => {
  const user = useUser()

  if (!user) return 'CANNOT_EDIT'

  return user?.editTranslationsPrivilege
}
